
import { defineComponent, ref, onMounted, computed } from 'vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { TanpokenUiItem } from '@/views/fuzoku-meisai/junsoku/data'
import TanpokenSettingItem from '@/views/fuzoku-meisai/junsoku/TanpokenSettingItem.vue'
import { UiItemsLogic } from '@/views/fuzoku-meisai/uiItemsLogic'
import { junsokuRepositories } from '@/repositories/fuzoku-meisai/junsoku/junsokuRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import JunsokuSettingTitle from '@/views/fuzoku-meisai/junsoku/JunsokuSettingTitle.vue'

const repository = junsokuRepositories.tanpoken

export default defineComponent({
  components: {
    JunsokuSettingTitle,
    TanpokenSettingItem,
    ResponseResultAlert,
    LoadingButton,
    ContentLayout
  },
  setup () {
    const loading = ref(false)
    const isSucceedResponse = ref(false)
    const requestError = ref<string | null>(null)
    const items = ref<TanpokenUiItem[]>([])
    const isAllValid = computed(() => {
      const allCount = items.value.length
      if (allCount === 0) {
        return true
      }
      return allCount === items.value.filter(i => i.isValid).length
    })

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        const data = await repository.list()
        items.value = data.map(v => ({ item: v, isValid: true }))
      })
      loading.value = false
    })

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()

      await callApiWrapper(requestError, async () => {
        const param = items.value.map(v => v.item)
        await repository.save(param)
        const data = await repository.list()
        items.value = data.map(v => ({ item: v, isValid: true }))
        isSucceedResponse.value = true
      })

      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedResponse.value = false
      requestError.value = null
    }

    const addItem = () => {
      const newId = UiItemsLogic.makeId(items.value)
      items.value.push({
        isValid: false,
        item: {
          id: newId,
          itemName: '',
          kimatsuTyouboKakaku: 0,
          tanpokenShurui: '',
          saimuNaiyou: '',
          kimatsuSaimuZandaka: 0
        }
      })
    }

    const onUpItem = (item: TanpokenUiItem) => UiItemsLogic.upUiItem(items.value, item)

    const onDownItem = (item: TanpokenUiItem) => UiItemsLogic.downUiItem(items.value, item)

    const onTrashItem = (item: TanpokenUiItem) => UiItemsLogic.removeUiItem(items.value, item)

    const onChangeInput = (item: TanpokenUiItem) => UiItemsLogic.updateUiItem(items.value, item)

    return {
      loading,
      isAllValid,
      isSucceedResponse,
      requestError,
      items,
      onDismissAlert,
      addItem,
      onUpItem,
      onDownItem,
      onTrashItem,
      onChangeInput,
      onClickRegister
    }
  }
})
